module.exports = "precision mediump float;\n\nattribute vec2 a_position;\nvarying vec2 v_position;\n\nvoid main() {\n  v_position=(a_position+1.0)*0.5;\n  v_position.y=1.0-v_position.y;\n  gl_Position = vec4(a_position,0.0,1.0);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./shaders/simple.vert
// module id = 6
// module chunks = 0